<template>
  <div class="layout-hint">
    <div class="hint-cont">
      <div class="hint-tip">
        <div class="hint-icon"
             v-if="icon">
          <slot name="icon">
            <img :src="iconSrc" alt="">
          </slot>
        </div>
        <div class="hint-msg">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconMsg from '../../assets/icons/icon-msg.png'
import IconEmpty from '../../assets/icons/icon-empty.png'
import IconNetwork from '../../assets/icons/icon-network.png'
import IconError from '../../assets/icons/icon-error.png'
export default {
  name: 'Hint',
  props: {
    icon: {
      type: Boolean,
      default: true
    },
    type: String
  },
  computed: {
    iconSrc: function () {
      switch (this.type) {
        case 'empty':
          return IconEmpty
        case 'network':
          return IconNetwork
        case 'error':
          return IconError
        default:
          return IconMsg
      }
    }
  }
}
</script>

<style lang="scss">
  .layout-hint {
    height: 100%;
    overflow: hidden;
    & > .hint-cont {
      position: relative;
      height: 100%;
      transform: translate(50%, 50%);
      & > .hint-tip {
        transform: translate(-50%, -50%);
        & > .hint-icon {
          text-align: center;
          img {
            max-width: 100%;
            height: 46px;
            margin: auto;
          }
        }
        & > .hint-msg {
          text-align: center;
          font-size: 12px;
          color: #909399;
          line-height: 200%;
          a {
            text-decoration: none;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
